<template>
  <span class="weight" v-if="value">
    {{formattedValue}} {{formattedUnit}}
  </span>
</template>

<script>
export default {
  name: 'weight',
  props: {
    value: Object,
  },
  computed: {
    formattedValue() {
      return this.$n(this.value.value);
    },
    formattedUnit() {
      return this.$t(`units.short.${this.value.unit}`);
    },
  },
  i18n: {
    messages: {
      de: {
        units: {
          short: {
            G: 'g',
            KG: 'kg',
          },
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// Weight.vue?27fe1026